export const NOW_VALUE = '$now';
export var DateTimeValueType = /*#__PURE__*/ function(DateTimeValueType) {
    DateTimeValueType["Relative"] = "Relative";
    DateTimeValueType["Specific"] = "Specific";
    return DateTimeValueType;
}({});

//# sourceMappingURL=default-values.js.map